import { useCan } from '@sentinel/web-core';
import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@/core/api/endpoints';
import { useActiveMission } from '@/core/mission/active-mission';
import { keys } from '@/core/query/query-keys';
import { navBadges } from './nav-badges';

const REFRESH_MS = 60_000;

/** The counters of the PCA sidebar. The queries are the dashboard's and the channel list's:
 *  shared with those pages and refreshed by the realtime channel, never a request of their own
 *  more than once a minute. */
export function useNavBadges(enabled: boolean) {
  const { missionId } = useActiveMission();
  const canDashboard = useCan('operations:view');
  const canComms = useCan('communications:view');
  const on = enabled && missionId !== null;
  const dashboard = useQuery({
    queryKey: keys.dashboard(missionId ?? 'none'),
    queryFn: () => endpoints.missions.dashboard(missionId as string),
    enabled: on && canDashboard,
    refetchInterval: REFRESH_MS,
  });
  const channels = useQuery({
    queryKey: keys.commsChannels(missionId ?? 'none'),
    queryFn: () => endpoints.communications.channels(missionId as string),
    enabled: on && canComms,
    refetchInterval: REFRESH_MS,
  });
  return on ? navBadges(dashboard.data, channels.data?.items) : {};
}
